import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosComman";

function useFetchMetaData({ value,create=false }) {
  const [metaData, setMetaData] = useState([]);
  const [loading, setLoading] = useState(false);
  async function getData() {
    setLoading(true);
    await axiosInstance
      .get(`/Master-Data/${value}`)
      .then((res) => {
        let data = res?.data?.data;
        let xyz = [];
        if(create == true){
          setMetaData(data);
        }else{
          data.forEach((i) => {
            let x = { label: i?.value, value: i?.value };
            xyz.push(x);
          });
          res?.data && setMetaData(xyz);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }
  useEffect(() => {
    if (value) getData();
  }, [value]);
  return { metaData, getData,loading };
}

export default useFetchMetaData;
